<template>
<AdminPanelEGiftsPackageSellingHistory />
</template>

<script>
import AdminPanelEGiftsPackageSellingHistory from '../components/AdminPanelEGiftsPackageSellingHistory.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEGiftsPackageSellingHistory
    },
    methods: {},
    mounted() {}
}
</script>